import mitt, { Emitter } from 'mitt';
import to from 'await-to-js';
import { getApi, getAppCode } from './init';
import { getAuthManager } from './auth-manager';

export enum USER_MANAGER_EVENT {
  GET_USER = 'get:user',
}

interface IUser {
  avatar: string;
  gender: string;
  industry: string;
  mobile: string;
  name: string;
  orgId: string;
  orgName: string;
  position: string;
  role: string;
  userId: string;
  solution: 'common' | 'art';
}

type IEventBody = Record<USER_MANAGER_EVENT, IUser | null>;

class UserManager {
  user: IUser | null = null;

  // 事件总线
  private _eventBus: Emitter<IEventBody> = mitt();
  private _fetching = false;

  private _emit<K extends USER_MANAGER_EVENT>(type: K, data: IEventBody[K]) {
    this._eventBus.emit(type, data);
  }

  on<K extends USER_MANAGER_EVENT>(type: K, handler: (data: IEventBody[K]) => void) {
    const fn = (args: any) => {
      handler(args);
    };
    this._eventBus.on(type, fn);
  }

  once<K extends USER_MANAGER_EVENT>(type: K, handler: (data: IEventBody[K]) => void) {
    const fn = (args: any) => {
      this._eventBus.off(type, fn);
      handler(args);
    };
    this._eventBus.on(type, fn);
  }

  async getUser<T>(refetch = false, getUserApi: () => Promise<T>) {
    return new Promise(async (resolve) => {
      function handle(user: IUser | null) {
        resolve(user);
      }

      if (this.user && !refetch) {
        resolve(this.user);
      } else {
        this.once(USER_MANAGER_EVENT.GET_USER, handle);
        if (!this._fetching) {
          this._fetching = true;
          const authManager = getAuthManager();
          const accessToken = await authManager.getAccessToken();
          if (!accessToken) {
            this._emit(USER_MANAGER_EVENT.GET_USER, null);
            return;
          }
          const { ucApi } = getApi();
          const [err, res] = await to(
            getUserApi
              ? getUserApi()
              : ucApi.getCurrent({
                  appCode: getAppCode(),
                }),
          );

          if (err) {
            console.log(err);
            this._emit(USER_MANAGER_EVENT.GET_USER, null);
          } else {
            this.user = res as IUser;
            this._emit(USER_MANAGER_EVENT.GET_USER, res as IUser);
          }
          this._fetching = false;
        }
      }
    });
  }
}

let userManager;
export function getUserManager() {
  if (!userManager) {
    userManager = new UserManager();
  }
  return userManager;
}
